import { singleton } from "tsyringe";
import router from "@/apps/routers/index";

// interface
import type { NavigationService } from "@/shared/libs/navigation/interface";

@singleton()
export default class NavigationServiceImpl implements NavigationService {
    public navigateTo = (path: string) => {
        router.push(path);
    };

    public navigateToHome = () => {
        router.push("/");
    };
}
